import ManageProfile from "../../pages/manage-profile";
import Orders from "../../pages/orders";
import Products from "../../pages/products";
import * as React from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import "./styles.scss";
import ProfileIcon from "../../assets/profile/profile.png";
import OrderIcon from "../../assets/profile/Orders.png";
import ProductIcon from "../../assets/profile/product.png";
import Associates from "../../pages/associates";
import { useDispatch, useSelector } from "react-redux";
import { postTabActive } from "../../redux/associates/action";
import { RoleEnum } from "../../shared/enums/role.enum.ts";

const { SUPER_ADMIN, ADMIN } = RoleEnum;

const ManageContainer = () => {
  const UserProfile = useSelector((state) => state.profile.userProfiles);
  const tabActive = useSelector((state) => state.userAssociations.tabActive);
  const dispatch = useDispatch();

  const profileTab = {
    title: "Profile",
    content: <ManageProfile />,
    icon: ProfileIcon,
  };
  const ordersTab = {
    title: "Orders",
    content: <Orders />,
    icon: OrderIcon,
  };
  const productsTab = {
    title: "Products",
    content: <Products />,
    icon: ProductIcon,
  };
  const associatesTab = {
    title: "Associates",
    content: <Associates />,
    icon: ProfileIcon,
  };

  const tabs = [
    ...(UserProfile.role !== SUPER_ADMIN ? [profileTab] : []),
    ordersTab,
    productsTab,
    ...([SUPER_ADMIN, ADMIN].includes(UserProfile.role) ? [associatesTab] : []),
  ];

  return (
    <Tabs
      defaultFocus={true}
      className="heder-tab"
      defaultIndex={tabActive}
      onSelect={(index) => dispatch(postTabActive(index))}
      selectedclassname="tabLinkFocus"
    >
      <TabList className="body-button">
        {tabs.map((tab) => {
          return (
            <Tab
              key={tab.title}
              className="tabLink"
              selectedClassName="tabLinkFocus"
            >
              <div
                style={{
                  paddingLeft: "45px",
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >
                <div style={{ display: "flex" }}>
                  <img
                    style={{
                      paddingRight: "15px",
                      width: "30px",
                      height: "30px",
                    }}
                    src={tab.icon}
                    alt="icon"
                  />
                </div>
                <span>{tab.title}</span>
              </div>
            </Tab>
          );
        })}
      </TabList>
      {tabs.map((item, index) => (
        <TabPanel key={index} style={{ width: "100%" }}>
          {item.content}
        </TabPanel>
      ))}
    </Tabs>
  );
};

export default ManageContainer;
